// Tên cảnh giới / tiểu cảnh cho hiển thị (GLOSSARY §1). Suy từ thang, không hard-code số cảnh giới.
import { fromStageL, realmDef, subStageId } from '@data/powerScale';
import { t } from './t';

/** "Luyện Khí tầng 3" · "Trúc Cơ Sơ Kỳ" từ bước toàn cục n = L − 1. */
export function stageLabel(step: number): string {
  const { realm, s } = fromStageL(step + 1);
  const id = realmDef(realm).id;
  return t('stage.label', { realm: t(`realm.${id}`), stage: t(`stage.${subStageId(realm, s)}`, { n: s }) });
}

export function realmLabel(step: number): string {
  return t(`realm.${realmDef(fromStageL(step + 1).realm).id}`);
}
